/**
 * Created by yibrahim on 20/07/2017.
 */
export class GuestCredit {
  constructor(public guestFirstName: string = null,
              public guestLastName: string = null,
              public ticketNumber: string = null,
              public feeAmountWaived: string = null,
              public valueWaived: string = null,
              public showFeeAmount: boolean = true,
              public showFareAmount: boolean = true)
  {}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/guest-credit.ts